export default __webpack_public_path__ + "static/media/horse-intro.3c46d507.png";